import 'whatwg-fetch' // polyfill for older browsers
import queryString from 'query-string'
import config from '@/app/config'
import * as R from 'ramda'

const client = {
  request ({uri, params = {}, method = 'get', headers = {}, data, token}) {
    let url = config.PHQ_PUBLIC_API_ENDPOINT + uri
    if (!R.isEmpty(params)) {
      url += '?' + queryString.stringify(params)
    }
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + token,
          'X-User-Agent': 'PHQ-Tableau-Connector/' + config.APP_VERSION
        }
      }).then(response => {
        if (response.ok) {
          return response.json()
        } else {
          // Handle error
          let error = new Error(response.statusText || response.status)
          error.code = (response.statusText || response.status)
          error.response = response
          throw error
        }
      }).then(result => {
        if (result.hasOwnProperty('error')) {
          reject(result)
        }

        resolve(result)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  }
}

export default client
